import dayjs from "dayjs";
import { humanizeMinutes } from "@therms/web-js";
import { upperFirst } from "lodash-es";
import * as xlsx from "xlsx";
//#region src/modules/Locations/shared/location-tour-runs-summary-download.ts
function locationTourRunsSummaryDownload(tours, deps, config) {
	const arrayOfArrays = [[
		"Name",
		"User",
		"Start",
		"End",
		"Duration",
		"Scans",
		"Status"
	]];
	tours.forEach((tour) => {
		const user = deps.usersById[tour.startedByUserId];
		arrayOfArrays.push([
			tour.checkpointTour.name,
			`${user.displayName}${user.idNumber ? ` (${user.idNumber})` : ""}`,
			tour.startDate ? dayjs(tour.startDate).format("MM/DD hh:mm A") : "",
			tour.endDate ? dayjs(tour.endDate).format("MM/DD hh:mm A") : "",
			tour.endDate ? humanizeMinutes(dayjs(tour.endDate).diff(tour.startDate, "minute")) : "",
			`${tour.checkpointScansCompleted}/${tour.checkpointScansTotal}`,
			upperFirst(tour.status)
		]);
	});
	const ws = xlsx.utils.aoa_to_sheet(arrayOfArrays);
	const wb = xlsx.utils.book_new();
	xlsx.utils.book_append_sheet(wb, ws, "Summary");
	if (config.format === "csv") xlsx.writeFile(wb, `${config.fileName}.csv`, { bookType: "csv" });
	else xlsx.writeFile(wb, `${config.fileName}.xlsx`, { bookType: "xlsx" });
}
//#endregion
export { locationTourRunsSummaryDownload };

//# sourceMappingURL=location-tour-runs-summary-download.js.map